import React, { lazy, useEffect } from 'react';

const PaymentOptionsComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-payment-options" */ '~/purchase-ui/src/app/steps/payment-options'
  )
);

export const PaymentOptionsRoute = () => {
  useEffect(() => {
    console.log('remounting');
  }, []);

  return <PaymentOptionsComponent />;
};
